var MIN_IMAGE_SIZE = 100000;
var MAX_IMAGE_SIZE = 15000000;
var DISPATCH_ENDPOINT = "https://commerce-image-services.warnerbros.com/v1/dispatch"; //prod

new Vue({
  el: "#frog",
  data: {
    isLoading: false,
    wW: window.innerWidth,
    width: 359,
    height: 499,
    ratio: 1.39,
    image: null,
    validText: true,
    fileType: "",
    uploadURL: "",
    errorMessage: "",
    uploadCrop: "",
    filename: "",
    imageUrl: "",
    previewUrl: "",
    pdfUrl: "",
    imageId: "",
    fullNameString: "Full Name",
    fullName: "",
    house: window.innerWidth <= 768 ? "Select one" : "",
    houses: "",
    wand: window.innerWidth <= 768 ? "Select one" : "",
    wands: "",
    consent: false,
    knownForOptions1: [
      "Alchemy",
      "Ancient Runes Expert",
      "Apparition",
      "Astronomy",
      "Auror",
      "Avid Quibbler Readership",
      "Care of Magical Creatures",
      "Charms",
      "Divination",
      "Famous Witch or Wizard Cards Collection",
      "Five-time Winner of Witch Weekly's Most Charming Smile Award",
    ],
    knownForOptions2: [
      "Herbology",
      "House Prefect",
      "Magizoologist",
      "Parseltongue",
      "Playing on the House Quidditch™ Team",
      "Potions",
      "Promoting Elfish Welfare",
      "Quidditch™ Captain",
      "Quidditch™ Chaser",
      "Quidditch™ Beater",
      "Quidditch™ Seeker",
      "Spotting Nargles",
      "Transfiguration",
      "Wizards Chess",
    ],
    knownFors: [],
    showBack: false,
    showHouseOptions: false,
    showWandOptions: false,
    showMobileOptions: false,
    inputType: "",
    inputSize: 0,
    isAndroid: false,
    attempts: [],
  },
  mounted() {
    var self = this;
    this.isAndroid = navigator.userAgent.includes("Android");
    //     console.log('isAndroid', this.isAndroid);
    //     console.log('navigator.userAgent', navigator.userAgent);
    this.uploadCrop = $("#cardImage").croppie({
      viewport: { width: self.width, height: self.height },
      boundary: { width: self.width, height: self.height },
      showZoomer: true,
      enableResize: true,
      enableOrientation: true,
      enforceBoundary: true,
    });
    this.uploadCrop.croppie("setZoom", 0.5);
    window.addEventListener("resize", this.reportWindowSize);
    this.reportWindowSize();
    var crOverlay = document.querySelector(".cr-overlay");
    if (crOverlay) {
      crOverlay.addEventListener(
        "touchmove",
        function (e) {
          e.preventDefault();
        },
        { passive: true }
      );
      crOverlay.addEventListener(
        "touchstart",
        function (e) {
          e.preventDefault();
        },
        { passive: true }
      );
    }
  },
  updated() {
    //       console.log('house', this.house);
    //       console.log('wand', this.wand);
    //       console.log('known fors', this.knownFors);
  },
  computed: {
    knownForString: function () {
      return this.knownFors.reduce(function (previousValue, currentValue) {
        var divider = previousValue ? ", " : "";
        return previousValue + divider + currentValue;
      }, "");
    },
    validated: function () {
      return (
        this.knownFors.length > 1 &&
        this.fullName !== "" &&
        this.wand !== "" &&
        this.wand !== "Select one" &&
        this.house !== "" &&
        this.house !== "Select one" &&
        this.image !== null &&
        this.consent &&
        this.validText
      );
    },
  },
  watch: {
    fullName: function (val) {
      var valText, notAllowed, notAllowed2;
      var reg =
        /^[A-Za-z\0-9\$\¢\€\£\¥\¤\+\-\*\/\÷\=\%\‰\”\’\"\#\@\&\_\(\)\,\.\;\:\¿\?\¡\!\\\|\{\}\<\>\[\]\§\¶\μ\`\^\~\©\®\™\»\«\°\¼\½\¾\Ƹ\±\¨\º\ \u00C0-\u017F]+/g;
      var allow =
        /[^A-Za-z\0-9\$\¢\€\£\¥\¤\+\-\*\/\÷\=\%\‰\”\’\"\#\@\&\_\(\)\,\.\;\:\¿\?\¡\!\\\|\{\}\<\>\[\]\§\¶\μ\`\^\~\©\®\™\»\«\°\¼\½\¾\Ƹ\±\¨\º\ \u00C0-\u017F]+/g;
      var emojis =
        /([^\u2700-\u27BF]|[^\uE000-\uF8FF]|[^\uD83C][^\uDC00-\uDFFF]|[^\uD83D][^\uDC00-\uDFFF]|[^\u2011-\u26FF]|[^\uD83E][^\uDD10-\uDDFF][^\uD800-\uDBFF][^\uDC00-\uDFFF])/g;
      var emojis2 = /[^\uD800-\uDBFF][^\uDC00-\uDFFF]/g;
      var emojis3 =
        /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi;
      //       var pict = /\p{Extended_Pictographic}/ug;
      var pict =
        /[\p{Emoji}\p{Emoji_Modifier}\p{Emoji_Component}\p{Emoji_Modifier_Base}\p{Emoji_Presentation}]/gu;
      if (val) {
        if (allow.test(val) || pict.test(val)) {
          this.validText = false;
          notAllowed = val.match(pict) || "";
          notAllowed2 = val
            .replace(pict, "")
            .split("")
            .filter(function (x) {
              return allow.test(x);
            });
          this.attempts.push(notAllowed);
          this.attempts.push(notAllowed2);
          this.errorMessage =
            "Sorry, " + notAllowed + notAllowed2 + " cannot be used.";
        } else {
          this.validText = true;
          this.errorMessage = "";
        }
        valText = val.replace(pict, "");
        valText = valText.replace(allow, "");
        this.fullNameString = valText.toLowerCase().toTitleCase();
        this.fullName = valText.toLowerCase().toTitleCase();
        //         return valText.toLowerCase().toTitleCase();
      } else {
        this.fullNameString = "Full Name";
      }
    },
    //     fullName: function (val) {
    //       if (val) this.fullNameString = val.toLowerCase().toTitleCase();
    //       else this.fullNameString = 'Full Name';
    //     },
    house: function (val) {
      if (val) this.onMobileHouseClose();
    },
    wand: function (val) {
      if (val) this.onMobileWandClose();
    },
    knownFors: function (val) {
      if (val.length === 3) this.onMobileKnownForClose();
    },
    houses: function (val) {
      if (val) this.house = val;
    },
    wands: function (val) {
      if (val) this.wand = val;
    },
  },
  methods: {
    reportWindowSize() {
      this.wW = window.innerWidth;
      var flipper = document.querySelector(".flip__wrapper");
      if (window.innerWidth <= 420 && flipper) {
        //         console.log('shrink');
        var newWidth = window.innerWidth * 0.9;
        var newHeight = newWidth * this.ratio;
        this.width = newWidth;
        this.height = newHeight;
        flipper.style.width = newWidth + "px";
        flipper.style.height = newHeight + "px";
        this.uploadCrop.croppie("setZoom", 0.5);
      } else if (flipper) {
        flipper.style.width = null;
        flipper.style.height = null;
        document.querySelector(".col--2").style.width = null;
        document.querySelector(".col--2").style.height = null;
      }
    },
    capitalize(e) {
      //       console.log('capitalize');
      this.fullName = e.target.innerText.toLowerCase().toTitleCase();
      this.fullNameString = e.target.innerText.toLowerCase().toTitleCase();
      this.$nextTick(function () {
        //             var inputLength = this.fullName.length;
        var newRange = document.createRange();
        var selection = window.getSelection();
        var node = this.$refs.editable.childNodes[0];
        //         console.log('node length', node.length);
        //       newRange.setStart(node, node.length);
        newRange.selectNode(node);
        newRange.collapse(false);
        selection.removeAllRanges();
        selection.addRange(newRange);
      });
    },
    onFullNameClick(e) {
      if (this.fullNameString === "Full Name") this.fullNameString = "";
    },
    onFullNameBlur(e) {
      if (this.fullNameString === "") this.fullNameString = "Full Name";
    },
    onFrontBtnClick(e) {
      e.preventDefault();
      this.showBack = false;
    },
    onBackBtnClick(e) {
      e.preventDefault();
      this.showBack = true;
    },
    onMobileHouseClick() {
      this.showHouseOptions = true;
    },
    onMobileHouseClose() {
      this.showHouseOptions = false;
    },
    onMobileWandClick() {
      this.showWandOptions = true;
    },
    onMobileWandClose() {
      this.showWandOptions = false;
    },
    onMobileKnownForClick() {
      this.showMobileOptions = true;
    },
    onMobileKnownForClose() {
      this.showMobileOptions = false;
    },
    onFakeButtonClick(e) {
      e.preventDefault();
      this.$refs.uploadRef.click();
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.fileType = files[0].type;
      this.createImage(files[0]);
    },
    createImage(file) {
      var self = this;
      var reader = new FileReader();
      reader.onload = function (e) {
        //                 console.log('image size: ', e.target.result.length);
        self.inputSize = e.target.result.length;
        self.inputType = e.target.result;
        if (e.target.result.length < MIN_IMAGE_SIZE) {
          self.errorMessage = "Image is too small.";
          self.attempts.push("too small: " + e.target.result.length);
          return false;
        }
        if (e.target.result.length > MAX_IMAGE_SIZE) {
          self.errorMessage = "Image is too large.";
          self.attempts.push("too large: " + e.target.result.length);
          return false;
        }
        self.errorMessage = "";
        self.image = e.target.result;
        self.uploadCrop.croppie("bind", {
          url: e.target.result,
        });
      };
      reader.readAsDataURL(file);
    },
    removeImage: function (e) {
      // console.log("Remove clicked");
      this.image = "";
    },
    uploadImage: async function () {
      this.isLoading = true;
      var self = this;
      var base64 = await this.uploadCrop
        .croppie("result", {
          type: "base64",
          size: {
            width: 1920,
            height: 2876,
          },
          format: "jpeg",
        })
        .catch(function (error) {
          console.log(error);
        });

      var content = {
        fullName: this.fullName.toLowerCase().toTitleCase(),
        house: this.house,
        wand: this.wand,
        knownFor1: this.knownFors[0],
        knownFor2: this.knownFors[1] ? this.knownFors[1] : "",
        knownFor3: this.knownFors[2] ? this.knownFors[2] : "",
        base64: base64,
        size: this.inputSize,
        attempts: this.attempts.join(","),
      };
      // 	  console.log(this.attempts);
      var submitContent = await fetch(DISPATCH_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(content),
      })
        .then((response) => {
          // console.log("response", response);
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
          self.isLoading = false;
          self.errorMessage =
            "There was an error with your submission. Please try again.";
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          // console.log(error.config);
        });

      if (typeof submitContent.data === "string") {
        self.isLoading = false;
        self.errorMessage = submitContent.data;
      } else if (submitContent.data.preview) {
        self.isLoading = false;
        self.previewUrl = submitContent.data.preview;
        self.pdfUrl = submitContent.data.pdf;
        self.imageId = submitContent.data.id;
        //             self.pdfUrl = 'https://example.com/example.pdf';

        setTimeout(function () {
          self.$refs.form.submit();
        }, 500);

        //           }));
      } else {
        self.isLoading = false;
        self.errorMessage =
          "There was an error with your submission. Please try again.";
      }
    },
  },
});

/* To Title Case © 2018 David Gouch | https://github.com/gouch/to-title-case */

// eslint-disable-next-line no-extend-native
String.prototype.toTitleCase = function () {
  "use strict";
  var smallWords =
    /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i;
  var alphanumericPattern = /([A-Za-z0-9\u00C0-\u00FF])/;
  var wordSeparators = /([ :–—-])/;

  return this.split(wordSeparators)
    .map(function (current, index, array) {
      if (
        /* Check for small words */
        current.search(smallWords) > -1 &&
        /* Skip first and last word */
        index !== 0 &&
        index !== array.length - 1 &&
        /* Ignore title end and subtitle start */
        array[index - 3] !== ":" &&
        array[index + 1] !== ":" &&
        /* Ignore small words that start a hyphenated phrase */
        (array[index + 1] !== "-" ||
          (array[index - 1] === "-" && array[index + 1] === "-"))
      ) {
        return current.toLowerCase();
      }
      /* Ignore intentional capitalization */
      if (current.substr(1).search(/[A-Z]|\../) > -1) {
        return current;
      }
      /* Ignore URLs */
      if (array[index + 1] === ":" && array[index + 2] !== "") {
        return current;
      }
      /* Capitalize the first letter */
      return current.replace(alphanumericPattern, function (match) {
        return match.toUpperCase();
      });
    })
    .join("");
};
